module.exports = __webpack_public_path__ + "img/yljk.29c9e02d.svg";